import request, { gameRequest } from "@/utils/request";

export const getGameList = () => gameRequest.get(`/game/chair-game/list`);

export const getChairInfo = () => gameRequest.get(`/game/chair-game`);

export const joinGame = (game_id) =>
  gameRequest.post(`/game/chair-game/join`, {
    game_id,
  });

export const setSelect = (index) =>
  gameRequest.post(`/game/chair-game/select`, {
    index,
  });

export const exchangeCoin = (count) =>
  gameRequest.post(`/game/exchange-game-coin`, {}, { params: { count } });

export const getWallet = () => gameRequest.get(`/game/wallet`);

export const getCoinRecord = (is_income = 1, page = 1) =>
  gameRequest.get(`/game/game-coin-record`, { params: { is_income, page } });

export const getGameType = () => gameRequest.get(`/game/game_type`);

export const getFruitInfo = () => gameRequest.get(`/game/fruit-game`);

export const getBombInfo = () => gameRequest.get(`/game/bomb-game`);
